import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  beforeLoad: async ({ context }) => {
    const { data } = await context.supabase.auth.getSession();
    throw redirect({ to: data.session ? "/projects" : "/login" });
  },
});
